import React from "react";
import "./FormInputs.scss";

const FormInput = ({
  onChangex,
  onChangey,
  heading,
  x,
  y,
  funUp,
  funDown,
  funLeft,
  funRight,
}) => {
  return (
    <div className="userName">
      <h3>{heading}</h3>
      <div className="userInputs">
        <input type="number" onChange={onChangey} value={y} />
        <input type="number" onChange={onChangex} value={x} />
      </div>
      <button onClick={funUp}>Up</button>
      <button onClick={funDown}>Down</button>
      <button onClick={funLeft}> Left</button>
      <button onClick={funRight}>Right</button>
    </div>
  );
};

export default FormInput;
